import {
  linkStart,
  linkEnd,
  boldStart,
  boldEnd
}
from './boldCovention';

export const firstNoLinkText = (text) => {
  const normalText = text.split(linkStart)[0];
  return normalText;
};

export const extractLinkText = (text) => {
  const linkText = text.split(linkStart)[1]
    .split(linkEnd)[0];
  return linkText;
};

export const lastNoLinkText = (text) => {
  const secondNormalext = text.split(linkEnd)[1];
  return secondNormalext;
};

export const extractBoldText = (text) => {
  const boldeText = text.split(boldStart)[1]
    .split(boldEnd)[0];
  return boldeText;
};
export const noBoldText = (text) => {
  const normalText = text.split(boldStart)[0];
  return normalText;
};